import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { useIsAuthenticated } from '@azure/msal-react';
import htmr from 'htmr';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import classes from './sideJobCard.module.scss';
import ApplyButton from './ApplyButton';
import SaveButton from '../../buttons/SaveButton/SaveButton';
import { removeSavedJob, saveJob } from '../../../../actions/jobs';
import { useWindowSize } from '../../../../utils/hooks';
import { createLinkForSharingJob, removeStyleAttribute } from '../../../../utils/helpers';
import { MOBILE_BREAKPOINT } from '../../../../utils/constants';
import ShareButton from '../../buttons/ShareButton/ShareButton';

dayjs.extend(relativeTime);

function SideJobCard(props) {
  const { job, closeHandler, applyHandler, jobsData } = props;
  const actualJobInfo = useSelector((state) => state.jobs.response?.find((item) => item.Id === job.Id));
  const size = useWindowSize();
  const [appliedJobButtonLabel, setAppliedJobButtonLabel] = useState('');
  const [isJobApplied, setIsJobApplied] = useState(null);

  const isAuthenticated = useIsAuthenticated();
  const { t } = useTranslation();

  useEffect(() => {
    const foundJob = jobsData?.find((item) => item?.Id === job.Id);

    setAppliedJobButtonLabel(foundJob?.IsApplied ? 'Applied' : 'Apply Now');
    setIsJobApplied(foundJob?.IsApplied);
  }, [jobsData, job]);

  return (
    <div className={classes.jobs_full_container}>
      <div className={classes.sideJob_header}>
        <p className={classes.close_icon}>
          <CloseIcon className="cursor-pointer" role="button" data-testid="close-icon" onClick={closeHandler} />
        </p>
        <h4>{job?.JobTitle}</h4>
        <h6>{job?.Location}</h6>
        <div className={`pt-3 ${classes.buttons_container}`}>
          <ApplyButton
            label={appliedJobButtonLabel}
            onClick={() => {
              applyHandler(job?.Id);
              if (size.width < MOBILE_BREAKPOINT) closeHandler();
            }}
            disabled={isJobApplied}
          />
          <Link
            to={`${isAuthenticated ? '/dashboard' : ''}/jobs/${job?.Id}`}
            data-testid="read-more"
            className={`${classes.read_more} ${classes.job_button}`}
            aria-hidden="true"
          >
            {t('common.general.readmore')}
          </Link>
          <SaveButton
            isSaved={actualJobInfo?.IsSaved}
            id={job.Id}
            saveDispatcher={saveJob}
            unsaveDispatcher={removeSavedJob}
          />
          {size.width > MOBILE_BREAKPOINT && (
            <ShareButton
              title={job?.JobTitle}
              text={job?.JobDescription}
              url={createLinkForSharingJob(window.location.origin, job.Id)}
            />
          )}
        </div>
      </div>
      <div className={classes.side_description}>
        <div className={classes.general}>
          <h6>
            {t('dashboard.jobs.card.reference')}:{' '}
            <Link data-testid="job-ref" to={`${isAuthenticated ? '/dashboard' : ''}/jobs/${job?.Id}`}>
              {job?.Id}
            </Link>
          </h6>
          <h6>
            {t('dashboard.jobs.card.industry')}: {job?.Industry}
          </h6>
          <h6>
            {t('dashboard.jobs.card.type')}: {job?.JobType}
          </h6>
          <h6>
            {t('dashboard.jobs.card.onsite')}/{t('dashboard.jobs.card.remote')}:{' '}
            {job?.Remotepostion ? t('dashboard.jobs.card.remote') : t('dashboard.jobs.card.onsite')}
          </h6>
          {job?.PublishedDate && (
            <h6>
              {t('dashboard.jobs.card.published')}: {dayjs(job?.PublishedDate).from(dayjs())}
            </h6>
          )}
        </div>
        <hr />
        <div className={`${classes.descriptionContent}`}>
          <p>{htmr(removeStyleAttribute(job?.JobDescription))}</p>
        </div>
      </div>
    </div>
  );
}

export default SideJobCard;
